"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const index_1 = tslib_1.__importDefault(require("./index"));
const Switch = (props) => {
    const { input } = props, restProps = tslib_1.__rest(props, ["input"]);
    return React.createElement(index_1.default, Object.assign({}, input, restProps));
};
exports.default = Switch;
